import { modifyLinkBehavior } from '../utils.js';
export default function galleryWidget() {
  const widgetName = 'galleryWidget';
  const widgetOpts = galleryWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  const linkedImages = true;

  return saffire.widgets.cardWidget($widgetHTML, {
    cardWidgetLoaded: function (data, _owl, hasData) {
      const cards = $widgetHTML.find('.card-widget-item');
      $widgetHTML.find('.card-content').remove();

      if (hasData) {
        modifyLinkBehavior(data, cards);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    maxItemsVisible: 5,
    itemsPerPanel: 1,
  });
}
